import { accordionAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const sltMobile = definePartsStyle({
    container: defineStyle({
        border: 'none',
        padding: 0,
    }),
    button: defineStyle({
        padding: 0,
        textStyle: 'body-base',
        color: 'slt-black.1000',
        fontWeight: 400,
        _expanded: {
            fontWeight: 600,
        },
    }),
    panel: defineStyle({
        textStyle: 'body-base',
        paddingX: 6,
        paddingY: 4,
    }),
});

const baseContainer = defineStyle({
    paddingTop: 4,
    paddingBottom: 4,
});

const baseButton = defineStyle({
    textStyle: 'body-base',
    color: 'slt-pepper.1000',
    paddingX: 0,
    paddingY: 2,
    _hover: {
        background: 'none',
    },
    _focus: {
        boxShadow: 'unset',
    },
});

const basePanel = defineStyle({
    textStyle: 'body-base',
    color: 'slt-pepper.1000',
    margin: 0,
    paddingX: 0,
    paddingTop: 4,
    paddingBottom: 0,
});

const baseStyle = definePartsStyle({
    button: baseButton,
    panel: basePanel,
    container: baseContainer,
});

const plpCategories = definePartsStyle({
    container: {
        ...baseContainer,
        paddingTop: 0,
        paddingBottom: 0,
        marginInlineStart: 4,
    },
    button: baseButton,
    panel: basePanel,
    root: {
        paddingTop: 0,
        paddingBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
});

const overlapping = definePartsStyle({
    container: {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        border: 'none',
    },
    button: {
        ...baseButton,
        backgroundColor: 'white',
        borderWidth: '1px',
        borderColor: 'slt-pepper.300',
        borderStyle: 'solid',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 4,
        alignSelf: 'stretch',
        padding: 4,
        fontWeight: 500,
        letterSpacing: '0.5px',
        borderTopLeftRadius: '2xl',
        borderTopRightRadius: '2xl',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomWidth: 0,
        _expanded: {
            borderBottomColor: 'transparent',
            paddingBottom: 4,
        },
        _hover: {
            backgroundColor: 'slt-pepper.50',
        },
    },
    panel: {
        textStyle: 'body-base-pepper-1000',
        margin: 0,
        backgroundColor: 'white',
        borderWidth: '1px',
        borderColor: 'slt-pepper.300',
        borderStyle: 'solid',
        borderTopWidth: 0,
        borderTopColor: 'transparent',
        borderRadius: 0,
        padding: 4,
        fontWeight: 400,
    },
});

export const Accordion = defineMultiStyleConfig({
    baseStyle,
    variants: {
        'slt-mobile': sltMobile,
        'plp-categories': plpCategories,
        overlapping,
    },
});
